// Sağlık Tur Mock Data
export const companyInfo = {
  name: "Sağlık Tur",
  phone: "+90 554 414 69 16",
  email: "info@sagliktur.com",
  address: "Türkiye",
  logo: "https://customer-assets.emergentagent.com/job_df92fc4b-51ef-4532-a3d1-6bfd4d6cb2da/artifacts/xsey0war_ChatGPT%20Image%2018%20Ara%202025%2023_57_29.png",
  slogan: "Güvenli Yolculuk, Huzurlu Seyahat",
  description: "Öğrenci, personel ve turizm taşımacılığında güvenilir çözüm ortağınız"
};

export const services = [
  {
    id: 1,
    title: "Öğrenci Taşımacılığı",
    description: "Okullardan evlere güvenli ve zamanında öğrenci servisi. Deneyimli sürücüler ve modern araç filosu ile çocuklarınız güvende.",
    icon: "GraduationCap"
  },
  {
    id: 2,
    title: "Personel Taşımacılığı",
    description: "İşyerlerine düzenli ve konforlu personel servisi. Kurumsal firmalar için özel çözümler sunuyoruz.",
    icon: "Briefcase"
  },
  {
    id: 3,
    title: "Şehir İçi Turizm",
    description: "Şehir içi gezi ve tur organizasyonları. Kültürel geziler, okul gezileri ve grup turları için ideal çözümler.",
    icon: "MapPin"
  },
  {
    id: 4,
    title: "Şehirler Arası Taşımacılık",
    description: "Türkiye genelinde şehirler arası konforlu ve güvenli ulaşım. Uzun yol seyahatlerinde rahatlığınız önceliğimiz.",
    icon: "Bus"
  }
];

export const features = [
  {
    id: 1,
    title: "Güvenli Sürüş",
    description: "Deneyimli ve profesyonel sürücü kadrosu"
  },
  {
    id: 2,
    title: "Modern Araçlar",
    description: "Bakımlı ve konforlu araç filosu"
  },
  {
    id: 3,
    title: "7/24 Destek",
    description: "Her zaman yanınızda müşteri hizmetleri"
  },
  {
    id: 4,
    title: "Uygun Fiyat",
    description: "Rekabetçi ve şeffaf fiyatlandırma"
  }
];

export const stats = [
  { value: "10+", label: "Yıllık Deneyim" },
  { value: "50+", label: "Araç Filosu" },
  { value: "5000+", label: "Mutlu Müşteri" },
  { value: "24/7", label: "Hizmet" }
];
